import { render, staticRenderFns } from "./FormCollab.vue?vue&type=template&id=70d4d2e4&"
import script from "./FormCollab.vue?vue&type=script&lang=js&"
export * from "./FormCollab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports